export default {
  tovList: [],
  viewKpi: false,
  viewAssignment: false,
  takeTab: true,
  overTab: false,
  takeKpiList: [],
  takePrjList: [],
  srchKpiList: [],
  srchPrjList: [],
  overKpiList: [],
  overPrjList: [],
  myKpiTree: [],
  myPrjList: [],
  param: {},
  totcnt: '',
  srchKpiColumns: [],
  srchPrjColumns: [],
  takeColumns: {},
  overColumns: {},
  kpiSystemChart: [],
  tempTree: [],
  tid: [],
};
